/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingContact } from './';
import {
    BillingContactFromJSON,
    BillingContactFromJSONTyped,
    BillingContactToJSON,
} from './';
import type { EInvoiceRouting } from './';
import {
    EInvoiceRoutingFromJSON,
    EInvoiceRoutingFromJSONTyped,
    EInvoiceRoutingToJSON,
} from './';
import type { LegalInformation } from './';
import {
    LegalInformationFromJSON,
    LegalInformationFromJSONTyped,
    LegalInformationToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalEntityDetailsResource
 */
export interface LegalEntityDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetailsResource
     */
    legalEntityId: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetailsResource
     */
    organizationId: string;
    /**
     * 
     * @type {LegalInformation}
     * @memberof LegalEntityDetailsResource
     */
    legalInformation: LegalInformation;
    /**
     * 
     * @type {BillingContact}
     * @memberof LegalEntityDetailsResource
     */
    billingContact: BillingContact;
    /**
     * 
     * @type {EInvoiceRouting}
     * @memberof LegalEntityDetailsResource
     */
    eInvoiceRouting?: EInvoiceRouting;
    /**
     * Whether the e-invoicing routing section applies for this entity (feature flag enabled and French-VAT eligible). Computed by the invoicing domain.
     * @type {boolean}
     * @memberof LegalEntityDetailsResource
     */
    eInvoiceRoutingApplicable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LegalEntityDetailsResource
     */
    hasMandatoryInformation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LegalEntityDetailsResource
     */
    isArchived?: boolean;
}

/**
 * Check if a given object implements the LegalEntityDetailsResource interface.
 */
export function instanceOfLegalEntityDetailsResource(value: object): value is LegalEntityDetailsResource {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('legalInformation' in value) || value['legalInformation'] === undefined) return false;
    if (!('billingContact' in value) || value['billingContact'] === undefined) return false;
    if (!('hasMandatoryInformation' in value) || value['hasMandatoryInformation'] === undefined) return false;
    return true;
}

export function LegalEntityDetailsResourceFromJSON(json: any): LegalEntityDetailsResource {
    return LegalEntityDetailsResourceFromJSONTyped(json, false);
}

export function LegalEntityDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'organizationId': json['organizationId'],
        'legalInformation': LegalInformationFromJSON(json['legalInformation']),
        'billingContact': BillingContactFromJSON(json['billingContact']),
        'eInvoiceRouting': json['eInvoiceRouting'] == null ? undefined : EInvoiceRoutingFromJSON(json['eInvoiceRouting']),
        'eInvoiceRoutingApplicable': json['eInvoiceRoutingApplicable'] == null ? undefined : json['eInvoiceRoutingApplicable'],
        'hasMandatoryInformation': json['hasMandatoryInformation'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
    };
}

export function LegalEntityDetailsResourceToJSON(value?: LegalEntityDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityId': value['legalEntityId'],
        'organizationId': value['organizationId'],
        'legalInformation': LegalInformationToJSON(value['legalInformation']),
        'billingContact': BillingContactToJSON(value['billingContact']),
        'eInvoiceRouting': EInvoiceRoutingToJSON(value['eInvoiceRouting']),
        'eInvoiceRoutingApplicable': value['eInvoiceRoutingApplicable'],
        'hasMandatoryInformation': value['hasMandatoryInformation'],
        'isArchived': value['isArchived'],
    };
}

